import { Trans, useTranslation } from "react-i18next"
import Text from "../../../../../../components/Text"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../../../../components/accordion/Accordion"
import { Spacer } from "../../../../../../components/spacer/Spacer"
import { styled, theme } from "../../../../../../styles/stitches.config"
import Separator from "../../../../../../components/Separator"
import { Div } from "../../../../../../components/div/Div"
import { CustomerType } from "@nano-portal/customers"
import { WEB_LINKS } from "../../../../../../constants/links"

interface Props {
  type: CustomerType
}

const ItemCard = styled(Div, {
  boxShadow: theme.shadows.default,
  paddingLeft: theme.space.s12,
  paddingRight: theme.space.s9,
  paddingTop: theme.space.s3_5,
  paddingBottom: theme.space.s3_5,
})

const ItemContentWrapper = styled(Div, {
  paddingRight: theme.space.s3,
})

export const SpotDisclaimers = ({ type }: Props) => {
  const { t } = useTranslation("acquisitionForm")

  return (
    <>
      <Text type="headerH2" css={{ width: "100%", textAlign: "center", display: "block", fontSize: "20px" }}>
        {t("spot_how_it_works_header")}
      </Text>

      <Spacer size={theme.space.s6} />

      <Accordion type="multiple">
        <ItemCard>
          <AccordionItem value="1">
            <AccordionTrigger>
              <Text type="headerH3" css={{ fontSize: theme.fontSizes.medium }}>
                {t("spot_fixed_contract_difference_header")}
              </Text>
            </AccordionTrigger>

            <AccordionContent>
              <Spacer size={theme.space.s2_5} />
              <Separator orientation="horizontal" />
              <Spacer size={theme.space.s8} />

              <ItemContentWrapper>
                <Text type="textsSmall">
                  <p>
                    <Trans t={t} i18nKey={`spot_fixed_contract_difference_description_1_${type}`}>
                      <a
                        style={{ color: theme.colors.secondary.value, textDecoration: "underline" }}
                        href={WEB_LINKS.dailyPrices}
                        target="_blank"
                        rel="noreferrer"
                      />
                    </Trans>
                  </p>

                  <br />
                  <p>{t(`spot_fixed_contract_difference_description_2_${type}`)}</p>
                </Text>
              </ItemContentWrapper>
            </AccordionContent>
          </AccordionItem>
        </ItemCard>

        <Spacer size={theme.space.s5} />

        <ItemCard>
          <AccordionItem value="2">
            <AccordionTrigger>
              <Text type="headerH3" css={{ fontSize: theme.fontSizes.medium }}>
                {t("spot_advantages_and_disadvantages_header")}
              </Text>
            </AccordionTrigger>

            <AccordionContent>
              <Spacer size={theme.space.s2_5} />
              <Separator orientation="horizontal" />
              <Spacer size={theme.space.s8} />

              <ItemContentWrapper>
                <Text type="textsSmall">{t("spot_advantages_and_disadvantages_description")}</Text>
              </ItemContentWrapper>
            </AccordionContent>
          </AccordionItem>
        </ItemCard>
      </Accordion>
    </>
  )
}
